module.exports = __webpack_public_path__ + "img/30_39.31d56344.png";